/**
 * Set detail line
 * @param {Object} payload - Detail line Object.
 */
export const setDetail = ({ commit, dispatch }, payload) => {
  return new Promise((resolve) => {
    commit('SET_KEY', payload.key)
    commit('SET_QUANTITY', payload.quantity)
    commit('SET_ORDERSENDER', payload.orderSender)
    commit('SET_ORDERRECEIVER', payload.orderReceiver)
    commit('SET_OBSERVATION', payload.observation)
    commit('product/SET_ID', payload.product.id)
    commit('product/SET_VENDORCODE', payload.product.vendor)
    commit('product/SET_PAYERCODE', payload.product.payer)
    commit('product/SET_DESCRIPTION', payload.product.description)
    commit('product/SET_PRICEBATCH', payload.product.totalAmount)
    commit('product/SET_UNIT', payload.product.unit)
    commit('product/SET_BATCHUNITS', payload.product.count)
    if(payload.itemStartDate && payload.itemEndDate) {
      commit('SET_ITEMSTARTDATE', new Date(payload.itemStartDate).toLocaleDateString('en-GB', {timeZone: 'Europe/Madrid'}))
      commit('SET_ITEMENDDATE', new Date(payload.itemEndDate).toLocaleDateString('en-GB', {timeZone: 'Europe/Madrid'}))
    } else if(payload.lineStartDate && payload.lineEndDate) {
      commit('SET_ITEMSTARTDATE', new Date(payload.lineStartDate).toLocaleDateString('en-GB', {timeZone: 'Europe/Madrid'}))
      commit('SET_ITEMENDDATE', new Date(payload.lineEndDate).toLocaleDateString('en-GB', {timeZone: 'Europe/Madrid'}))
    }
    Promise.all([
      dispatch('discountsCharges/empty')
      .then(() => {
        if (!Array.isArray(payload.discountsCharges)) return
        payload.discountsCharges.forEach(discount => {
          commit('discountsCharges/ADD', discount)
        })
      }),
      dispatch('taxes/empty')
      .then(() => {
        if (!Array.isArray(payload.taxes)) return
        payload.taxes.forEach(rate => {
          commit('taxes/ADD', rate)
        })
      }),
      dispatch('deliveryNotes/empty')
      .then(() => {
        if (!Array.isArray(payload.deliveryNotes)) return
        payload.deliveryNotes.forEach(note => {
          commit('deliveryNotes/ADD', note)
        })
      }),
      dispatch('inmobilizedData/empty')
      .then(() => {
        if (!Array.isArray(payload.inmobilizedData)) return
        payload.inmobilizedData.forEach(note => {
          commit('inmobilizedData/ADD', note)
        })
      }),
      dispatch('officeFinancialExpenses/empty')
      .then(() => {
        if (!Array.isArray(payload.officeFinancialExpenses)) return
        payload.officeFinancialExpenses.forEach(note => {
          commit('officeFinancialExpenses/ADD', note)
        })
      })
    ]).then(() => {
      resolve()
    })
  })
}

export const emptyDetail = ({ commit, dispatch }, status) => {
  return new Promise((resolve, reject) => {
    commit('SET_KEY', undefined)
    commit('SET_QUANTITY', undefined)
    commit('SET_ORDERSENDER', undefined)
    commit('SET_ORDERRECEIVER', undefined)
    commit('SET_OBSERVATION', undefined)
    commit('product/SET_ID', undefined)
    commit('product/SET_VENDORCODE', undefined)
    commit('product/SET_PAYERCODE', undefined)
    commit('product/SET_DESCRIPTION', undefined)
    commit('product/SET_PRICEBATCH', undefined)
    commit('product/SET_UNIT', 'EUR')
    commit('product/SET_BATCHUNITS', undefined)
    commit('SET_ITEMSTARTDATE', undefined)
    commit('SET_ITEMENDDATE', undefined)
    Promise.all([
      dispatch('discountsCharges/empty'),
      dispatch('taxes/empty'),
      dispatch('deliveryNotes/empty'),
      dispatch('inmobilizedData/empty'),
      dispatch('officeFinancialExpenses/empty')
    ]).then(() => {
      // commit('NEW_LINE_STATUS', status)
      resolve()
    })
  })
}

export const addDetailTaxes = ({ commit, dispatch }, status) => {
  return new Promise((resolve, reject) => {
    Promise.all([
      dispatch('taxes/initialize')
    ]).then(() => {
      resolve()
    })
  })
}
